<script setup lang="ts">
import AppLogo from './AppLogo.vue';

/**
 * Login/auth layout — full viewport, centered, max-420px panel.
 * Default slot for the form. Optional `logo` slot to override the default logo.
 */
</script>

<template>
  <section class="auth-gate">
    <div class="auth-gate__panel">
      <div class="auth-gate__head">
        <slot name="logo">
          <AppLogo />
        </slot>
        <slot name="head"></slot>
      </div>
      <div class="auth-gate__body">
        <slot></slot>
      </div>
    </div>
  </section>
</template>
